export default {
  formats: {
    date: {
      short: 'DD.MM.YYYY',
      long: 'DD.MM.YYYY HH:mm',
      describe: 'MMMM Do YYYY, h:mm A',
    },
  },
  language: {
    de: 'Tedesco',
    en: 'Inglese',
    it: 'Italiano',
    fr: 'Francese',
    sp: 'Spagnolo',
    pl: 'Polacco',
  },
  search: 'Cerca',
  goBack: 'Indietro',
  signIn: {
    title: 'Accedi',
    dontHaveAccount: 'Non hai un account?',
  },
  signUp: {
    title: 'Registrati',
    info:
      'Registrandoti accetti i nostri  <0>{{privacy}}</0> e <1>{{terms}}</1>.',
    promotions: 'Non voglio ricevere Email di aggiornamento o promozioni',
    alreadyHaveAccount: 'Hai già un account?7',
    serviceterms: 'Accetto <0>{{service}}</0>.',
    dataprocessing: 'Accetto <0>{{agreement}}</0>.',
  },
  signOut: {
    title: 'Sign out',
  },
  email: {
    label: 'Indirizzo Email',
    placeholder: 'Indirizzo Email',
    taken: 'La Email è già stata utilizzata',
  },
  password: {
    label: 'Password',
    placeholder: 'Inserire password',
    mismatch: 'Le passowrd devono combaciare',
  },
  passwordConfirmation: {
    label: 'Confermare password',
    placeholder: 'Inserire conferma password',
  },
  firstName: {
    label: 'Nome',
    placeholder: 'Inserire Nome',
  },
  lastName: {
    label: 'Cognome',
    placeholder: 'Inserire Cognome',
  },
  activationKey: {
    label: 'ID-TICKET',
    placeholder: 'Inserire ID-TICKET',
  },
  companyName: {
    label: 'Nome Compagnia',
    placeholder: 'Inserire Nome Compagnia',
  },
  contactPerson: {
    label: 'Persona di riferimento',
    placeholder: 'Inserire nome della Persona di riferimento',
  },
  country: {
    label: 'Stato',
  },
  address: {
    label: 'Indirizzo',
    placeholder: 'Inserire Indirizzo',
  },
  city: {
    label: 'Città',
    placeholder: 'Inserire Città',
  },
  zip: {
    label: 'Codice Postale',
    placeholder: 'Inserire Codice Postale',
  },
  web: {
    label: 'Pagina Web',
    placeholder: 'Inserire pagina Web',
  },
  uid: {
    label: 'P. IVA',
    placeholder: 'Inserire P. IVA',
  },
  vatId: {
    label: 'Regione',
    placeholder: 'Es. E1234567890',
  },
  state: {
    label: 'Procincia',
    placeholder: 'Inserire Provincia',
  },
  street: {
    label: 'Via',
    placeholder: 'Inserire via',
  },
  phone: {
    label: 'Telefono',
    placeholder: 'Inserire Telefono',
  },
  forgot: {
    title: 'Password dimenticata',
    info:
      'Non preoccuparti! Inserisci la tua Email e ti invieremo un link per ripristinare la tua password.',
    button: 'Invia link per ripristinare password.',
    password: 'Password dimenticata?',
  },
  header: {
    profile: 'Profilo',
    settings: 'Impostazioni',
    companyInfo: 'Informazioni Compagnia',
    selectMill: 'Seleziona Centro di Produzione',
  },
  footer: {
    menu: {
      aboutUs: {
        title: 'About us',
        content:
          "Follow-Me! Technology Group sviluppa e distribuisce hyperDENT®, Un software per i processi di produzione CAM. La casa madre di FOLLOW-ME! Technology GmbH è presos Monaco di Baviera dove il nostro CEO Dr. Ferdinand Schwenkert e CTO Günter Linseis, responsabile dell'innovazione e dello sviluppo delle novità del prodotto, continuano a guardare al futuro del settore.  <br> <br> Gli altri uffici di FOLLOW-ME! Technology Group sono distribuiti in tutto il mondo come in Italia, Cina, Giappone, Corea, Singapore e negli USA.",
        ceoMessage:
          '“Vogliamo fornire un software dentale per creare un valore aggiunto al processo di digitalizzazione ed automatizzazione.”',
      },
      contact: {
        title: 'Contratto',
        content:
          '<strong>FOLLOW-ME!South Europe TECHNOLOGY srl, via Martiri di Belfiore,1 20017 RHO (MI) <br> Tel.: +39 029307814 . <br> E-Mail: info.see@fm-dental.com</strong>',
      },
      desktopApp: {
        title: 'Desktop App',
        content: "<strong>Scarica l'App Desktop qui</strong>",
      },
      privacyPolicy: {
        title: 'Privacy policy',
        content:
          '<strong>Data protection is a matter of very high importance for FOLLOW-ME! Technology GmbH. Use of our website is generally possible without the need to provide personal data. Personal data is only processed to the extent necessary for the ability to provide a functioning website and the content and services offered through it. The processing of personal data of our users normally only takes place with the userâ€™s prior consent. An exception to this exists in cases where it is not possible to obtain consent in advance due to reasons of fact and where processing of the data is permitted under the provisions of law.</strong>',
      },
      termsOfService: {
        title: 'Termini del Servizio',
        content:
          "<strong>Stiamo lavorando per aggiornare i termini di servizio, controllare più tardi i termini e condizioni aggiornati per l'utilizzo di hyperDENT Connect.</strong>",
      },
      dataProcessing: {
        title: 'Accordo gestione dati',
        content:
          "<strong>Stiamo lavorando per aggiornare i termini di servizio, controllare più tardi i termini e condizioni aggiornati per l'utilizzo di hyperDENT Connect.</strong>",
      },
    },
  },
  home: {
    home: 'Home',
    subtitle: 'hyperDENT Connect',
    title: 'Connettiti con gli Expert',
    content: 'Condividi i tuoi lavori nel modo più semplice',
    reasons: {
      title: 'Perchè usare hyperDENT Connect?',
      reason1: {
        title: "L'odontoiatria digitale sta modificanto i requisiti. ",
        content:
          'Maggiore produttività, maggiore flessibilità, maggiore spazio e processi più lineari.',
      },
      reason2: {
        title: 'Personalizza i tuoi servizi cloud',
        content:
          'Il nuovo servizio cloud completamente modulabile, personalizzabile e dalle alte prestazioni permette ai Centri di Produzione di aprirsi a nuove possibilità e di raggiungere ulteriori traguardi.',
      },
      reason3: {
        title: 'Semplice accesso al cloud ',
        content:
          "hyperDENT Connect consente l'accesso ai file dei tuoi clienti tamite un app disponibile da ogni device connesso ad Internet",
      },
    },
    policiesupdate: {
      title: 'Policy Update(s)',
      content:
        'Acconsenti al trattamento dei termini di utilizzo ed ai dati personali.',
    },
  },
  welcome: {
    title: 'Benvenuto in hyperDENT Connect',
    content:
      'hyperDENT Connect è una piattaforma per la condivisione dei file dentali. Permette uno scambio tra i clienti ed il centro di produzione in tempo reale ed uno strumento di comunicazione semplice ed immediato. ',
    landingPage: {
      title: '1-Crea la tua pagina',
      content: '',
      button: 'Impostazioni della tua Pagina',
    },
    inviteClients: {
      title: '2. Invita i clienti',
      content:
        'Aggiungi i laboratori o gli studi ai tuoi clienti invitandoli con il link preimpostato. ',
      button: 'Invita i clienti',
    },
  },
  labWelcome: {
    title: 'Istruzioni',
    content: 'Titolo: testo qui',
    serviceApp: {
      title: 'Servizio App',
      content: '',
      button: "Scarica l'App",
    },
    dashboard: {
      title: 'Dashbord',
      content: '',
      button: 'Vai al Pannello di Controllo',
    },
  },
  orders: {
    title: 'Ordini',
    deleted: 'Cancellato',
    deletedFilesInfo:
      'I file per questo progetto sono stati cancellati perchè la durata di conservazione dei file è scaduta.',
    noSearch: 'Nessun risultato della ricerca',
    noOrders: 'Nessun ordine creato',
    winApp: "Gli ordini sono creati dall'applicazione",
    downloadApp: 'Scarica App',
    columns: {
      orderId: 'ID Ordine',
      name: 'Nome Ordine',
      date: 'Data',
      messages: 'Messaggi',
      components: 'Componenti',
      client: 'Clienti',
      responsible: 'Responsabile Progetto',
      download: 'Download',
      report: 'Report',
    },
    component: {
      columns: {
        name: 'Componente',
        status: 'Stato',
        messages: 'Messaggi',
        files: 'Files',
        comment: 'Commento',
      },
    },
    messages: 'messaggi',
    message: 'messaggio',
    newMessage: 'nuovo',
    select: {
      any: {
        client: 'Qualsiasi Cliente',
        responsible: 'Qualsiasi Utente',
      },
    },
  },
  project: {
    download: {
      flat: 'Piano',
      hierarchical: 'Gerarchica',
    },
  },
  component: {
    orders: 'Ordini',
    component: 'Componente',
    status: {
      label: 'Stato del Componente',
      any: 'Qualsiasi Stato',
      open: 'Aperto',
      closed: 'Chiuso',
      downloaded: 'Scaricato',
    },
    orderId: 'ID Ordine',
    project: 'Progetto',
    preview: 'Preview Componente',
    documents: 'Documenti Componente',
    downloadAll: 'Scarica tutti',
    downloads: 'Documenti da scaricare',
    uploadPdf: 'Carica Pdf',
    noFiles: 'No File',
    messages: {
      title: 'Messaggi',
      message: {
        placeholder: 'Scrivi un messaggio',
      },
      button: 'Manda un messaggio',
    },
    upload: {
      title: 'Aggiungi un documento',
      name: {
        label: 'Nome documento',
        placeholder: 'Inserirsci nome documento',
      },
      button: 'Carica',
    },
    download: {
      deleteConfirm: {
        title: 'Cancella documento',
        message: 'Sei sicuro di voler cancellare il documento',
        buttonOk: 'Cancella',
        buttonCancel: 'Cancella',
      },
      deleteToast: {
        title: 'Cancella documento',
        message: 'Documento cancellato',
      },
      uploadToast: {
        title: 'Carica documento',
        message: 'Documento caricato',
      },
    },
    updateToast: {
      title: 'Carica Componente',
      message: 'Componente caricato con successo',
    },
    messageCreateToast: {
      title: 'Manda un messaggio',
      message: 'Messaggio inviato',
    },
    updateOrderToast: {
      title: 'Aggiorna Ordine',
      message: "L'Orine è stato aggiornato con successo",
    },
  },
  fileUpload: {
    label: 'Drag & drop o clicca per caricare',
  },
  clients: {
    title: 'Clienti',
    addClient: 'Aggiungi Cliente',
    status: {
      label: 'Stato',
      any: 'Qualsiasi Stato',
      active: 'Attivo',
      inactive: 'Inattivo',
    },
    columns: {
      company: 'Compagnia',
      email: 'Email',
      lab: 'Nome Laboratorio',
      contactPerson: 'Persona di Riferimento',
      status: 'Stato',
    },
    actions: {
      sendInvite: 'Invia Invito',
      delete: 'Cancella',
      blocked: 'Blocca',
      unBlock: 'Sblocca',
    },
    deleteConfirm: {
      title: 'Cancella Cliente',
      message: 'Sei sicuro di voler cancellare il cliente?',
      buttonOk: 'Cancella',
      buttonCancel: 'Cancella',
    },
    blockedConfirm: {
      title: 'Blocca cliente',
      message: 'Sei sicuro di bloccare il cliente?',
      buttonOk: 'Blocca',
      buttonCancel: 'Cancella',
    },
    unblockedConfirm: {
      title: 'Sblocca cliente',
      message: 'Sei sicuro di sbloccare il cliente?',
      buttonOk: 'Sblocca',
      buttonCancel: 'Cancella',
    },
    deleteToast: {
      title: 'Cancella cliente',
      message: 'Cliente cancellato',
    },
    blockToast: {
      title: 'Blocca cliente',
      message: 'Cliente bloccato',
    },
    unblockToast: {
      title: 'Sblocca cliente',
      message: 'Cliente sbloccato',
    },
    blockNotAllowedToast: {
      title: 'Sblocca cliente',
      message:
        'Il cliente è bloccato dal sistema, contatta il tuo amministratore',
    },
    client: {
      title: 'Aggiungi cliente',
      button: 'Aggiungi Cliente',
    },
    activation: {
      title: 'Istruzioni di attivazione',
      info:
        'Cliente aggiunto con successo. Puoi copiare e usare questo messaggio per contattare il cliente appena aggiunto.',
      message: {
        label: 'Messaggio di Invito',
        placeholder: 'Inserire Messaggio di Invito',
      },
      copy: 'Copia messaggio',
      send: 'Invia Email',
      confirm: {
        title: 'Email di Istruzioni',
        message: 'Email di Istruzioni è stata inviata al cliente',
        buttonOk: 'Chiudi',
      },
      errorConfirm: {
        title: 'Errore di attivazione',
        buttonOk: 'Ok',
      },
    },
    millingcenterClientAdded: {
      title: 'Centro di Produzione Aggiunto',
      message:
        "Il cliente del Centro di Produzione '{{millClient}}' è stato aggiunto",
      buttonOk: 'Bene',
    },
  },
  messages: {
    title: 'Messaggi',
    status: {
      any: 'Qualsiasi Messaggio',
      read: 'Letto',
      unread: 'Non Letto',
    },
    noMessages: 'Non hai messaggi',
  },
  settings: {
    title: 'Impostazioni',
    tabs: {
      landingPage: 'Pagina Principale',
      companyDetails: 'Informazioni Compagnia',
      users: 'Utenti',
      licenseKeys: 'Chiavi di licenza',
    },
    company: {
      logo: {
        title: 'Logo Compagnia',
        label: 'Logo',
      },
      info: {
        title: 'Info Compagnia',
      },
      button: 'Update',
      message: {
        update: 'Prego, aggiorna le tue Informazioni Compagnia',
      },
      error: {
        title: 'Errore',
        message:
          'Si è verificato un errore durante il salvataggio della pagina.',
      },
    },
    users: {
      add: 'Aggiungi Utente',
      edit: 'Modifica Utente',
      roles: {
        title: 'Ruoli',
        all: 'Tutti i Ruoli',
        admin: 'Amministratore',
        user: 'Utente',
      },
      columns: {
        name: 'Nome',
        email: 'Email',
        role: 'Ruolo',
      },
      actions: {
        delete: 'Cancella',
        edit: 'Modifica',
      },
      deleteConfirm: {
        title: 'Cancella utente',
        message: "Sei sicuro di cancellare l'utente?",
        buttonOk: 'Cancella',
        buttonCancel: 'Cancella',
      },
      addToast: {
        title: 'Aggiungi utente',
        message: 'Utente creato',
      },
      editToast: {
        title: 'Modifica Utente',
        message: 'Utente aggiornato',
      },
      deleteToast: {
        title: 'Cancella utente',
        message: 'Utente cancellato',
      },
      error: {
        title: 'Errore',
        message:
          'Si è verificato un errore mentre si salvavano i dettagli utente',
      },
    },
    licenseKey: {
      add: 'Aggiungi chiave di licenza',
      columns: {
        licenseKey: 'Chiave di Licenza',
        placeholder: 'Inserisci Chiave di Licenza',
        enableCollection: 'Abilita raccolta dati',
      },
      actions: {
        delete: 'Cancella',
      },
      deleteConfirm: {
        title: 'Cancella Chiave di Licenza',
        message: 'Sei sicuro di voler cancellare la Chiave di Licenza?',
        buttonOk: 'Cancella',
        buttonCancel: 'Cancella',
      },
      addToast: {
        title: 'Aggiungi chiave di licenza',
        message: 'Chiave di licenza aggiunta',
      },
      editToast: {
        title: 'Modifica chiave di licenza',
        message: 'Chiave di licenza modificata',
      },
      deleteToast: {
        title: 'Cancella Chiave di licenza',
        message: 'Chiave di Licenza cancellata',
      },
      error: {
        title: 'Errore',
        message: 'Errore durante invio chiave di licenza',
      },
    },
    landingPage: {
      intro: 'Crea la tua Pagina Principale',
      copy: {
        label: 'Copia url',
        button: 'Copia',
      },
      logo: 'Logo',
      header: {
        label: 'Titolo',
        placeholder: 'Scrivi Titolo',
      },
      content: {
        label: 'Contenuti',
        placeholder: 'Scrivi una descrizione',
      },
      update: 'Update',
      preview: {
        btnTxt: 'Mostra Pagina Principale',
        closeBtnTxt: 'Chiudi Preview',
        signIn: 'Accedi',
      },
      logoAlt: 'Logo Compagnia',
      notify: {
        title: 'Aggiorna pagina principale',
        message: 'La pagina principale non è stata rinnovata. Vuoi farlo ora?',
        okText: 'Procedi',
        cancelText: 'Salta per ora',
      },
    },
  },
  imageUpload: {
    button: 'Browse',
  },
  countries: {
    empty: 'Seleziona una Nazione',
    de: 'Germania',
    us: "Stati Uniti d'America",
    es: 'Spagna',
  },
  support: {
    title: 'Supporto',
    tabs: {
      contact: 'Contatto',
      downloadApp: "Scarica l'App",
    },
    contact: {
      info: 'Come possiamo aiutarti?',
      title: 'Scrivici',
      topic: {
        label: 'Argomento',
        placeholder: 'Di cosa vuoi parlare?',
      },
      topics: {
        empty: 'Scegli un Argomento',
        topicA: 'Argomento A',
        topicB: 'Argomento B',
        topicC: 'Argomento C',
      },
      message: {
        label: 'Messaggio',
      },
      submit: 'Invia',
      callUs: 'Chiamaci',
      line: 'Numero di Telefono del Supporto',
      phone: 'Tel.: +49 89 452 170 60',
      fax: 'Fax.: +49 89 452 170 69',
      sendEmailToast: {
        title: 'Email di conttato',
      },
    },
    downloadApp: {
      info: 'Applicazione Desktop per il tuo PC',
      download: 'Download',
      toastTitle: "Scarica l'App",
      notFound: "L'App non è disponibile",
    },
  },
  account: {
    title: 'Account',
    tabs: {
      company: 'Informazioni Compagnia',
      settings: 'Impostazioni',
      profile: 'Profilo',
    },
    company: {
      companyInfo: 'Gestisci le informazioni della tua Compagnia',
      logo: 'Logo Compagnia',
      information: 'Info',
      contact: 'Contatto',
      address: 'Indirizzo',
      shipping: {
        title: 'Spedizione',
        address: 'Indirizzo di Spedizione',
        sameAsAddress: 'Stesso Indirizzo',
        street: {
          label: 'Via',
          placeholder: 'Inserisci via di spedizione',
        },
        city: {
          label: 'Città',
          placeholder: 'Inserisci città di spedizione',
        },
        zip: {
          label: 'Codice Postale',
          placeholder: 'Inserisci Codice Postale',
        },
      },
      button: 'Update',
    },
    settings: {
      info: 'Modifica i tuoi dati personali',
      password: {
        title: 'Password',
        label: 'Nuova password',
        placeholder: 'Scrivi nuova password',
      },
      passwordConfirmation: {
        label: 'Conferma nuova password',
        placeholder: 'Scrivi e conferma password',
      },
      updatePassword: 'Aggiorna password',
      notifications: {
        title: 'Notifiche',
        notificationOnNewMessageReceived: 'Nuovo Messaggio ricevuto',
        sendEmailOnNewMessageReceived: 'Email su nuovo messaggio',
        notificationOnNewProjectIsCreated: 'Nuovo ordine creato',
        sendEmailOnNewProjectIsCreated: 'Emeil su nuovo ordine',
        notificationOnOrderProcessStart: "Processo d'Ordine iniziato",
        notificationOnOrderProcessCompleted: "Processo d'Ordine completato",
      },
      language: {
        title: 'Lingua',
      },
      project: {
        title: 'Progetto',
        folderStructure: 'Scarica struttura cartella',
      },
    },
    profile: {
      info: 'Imposta le tue informazioni del Profilo',
      button: 'Update',
    },
    updateProfileToast: {
      title: 'Aggiorna profilo',
      message: 'Profilo aggiornato',
    },
    updatePasswordToast: {
      title: 'Aggiorna password',
      message: 'Password aggiornata',
    },
    updateNotificationToast: {
      title: 'Nuova notifica',
      message: 'Notifica aggiornata',
    },
    updateLanguageToast: {
      title: 'Aggiorna lingua',
      message: 'Lingua aggiornata',
    },
    updateCompanyToast: {
      title: 'Aggiorna compagnia',
      message: 'Compagnia aggiornata',
    },
    invalidVAT: {
      title: 'VAT Invalido',
      message: 'Il codice VAT non è corretto, prego inserirne uno valido.',
    },
  },
  switch: {
    on: 'On',
    off: 'Off',
  },
  auth: {
    registerConfirm: {
      title: 'Link di conferma',
      message:
        "Vi abbiamo inviato un link di conferma per email. Prego controlla la mail per attivare l'account",
      buttonOk: 'OK',
    },
    confirmationConfirm: {
      title: 'Registrazione',
      message:
        'Benvenuto {{name}}! Il tuo account è attivo. Puoi usare la piattaforma.',
      buttonOk: 'Bene',
    },
    forgotConfirm: {
      title: 'Dimenticata conferma password',
      message: 'Per ripristinare la password controlla la tua email.',
    },
    resetConfirm: {
      title: 'Reimposta la password di conferma',
      message: 'La tua password è stata cambiata',
    },
    accountCreationConfirm: {
      title: 'Registrazione con successo',
      error: 'Errore durante la Registrazione',
      message:
        'Benvenuto {{name}}! Il tuo account è attivo. Puoi usare la piattaforma.',
      buttonOk: 'Bene',
    },
    millCenterAdded: {
      title: 'Centro di Produzione aggiunto',
      message: "Ti sei unito a '{{millName}}' .",
      buttonOk: 'Bene',
    },
  },
  reset: {
    title: 'Reset password',
    info: 'Prego, inserisci la tua nuova password',
    button: 'Cambia la tua password',
  },
  accountCreation: {
    title: 'Creazione account',
    info: "Pre completare la creazione dell'Account inserisci una password.",
    password: {
      label: 'Crea password',
      placeholder: 'Inserisci password',
    },
    button: 'Attiva Account',
  },
  invitation: {
    title: 'Invito',
    emailLabel: 'Email',
    message: "Sei stato invitato da '{{millName}}' .",
    submitBtnText: 'Crea un nuovo Account',
    connectToAccount: 'Unisciti ad un Account esistente',
    connectToAccountMsg:
      'Sei hai un Account hyperDENT Connect esistente puoi collegarlo.',
    or: 'o',
    addMillToAccountTxt:
      'Aggiungi questo Centro di Produzione a questo Account',
    createNewAccount: 'Crea un nuovo Account',
    sendConfirmationEmail: 'Invia email di conferma',
    existingAccount: 'Account Esistente',
    existingAccountMsg:
      "L'Email che hai utilizzato è già associata ad un Account hyperDENT Connect. Puoi aggiungere un nuovo account usando una email differente.",
  },
  landingPage: {
    signIn: 'Accedi',
  },
  unsavedChanges: {
    message: 'Hai dei cambiamenti non salvati, vuoi uscire?',
  },
  contract: {
    title: 'Contratto',
    error: 'Errore',
    tabs: {
      contractType: {
        title: 'Tipo di contratto',
        subscribe: 'Sottoscrivi',
        unsubscribe: 'Elimina Sottoscrizione',
        resubscribe: 'Sottoscrivi nuovamente',
        addOnConfirmation:
          'I file sono mantenuti per {{addOnDuration}} giorni (â‚¬{{getPromotionalPrice}}/month) è aggiunto al tuo contratto e saranno conteggiati nel prossimo pagamento.',
        addOnUnsubscription:
          'Il numero di file mantenuti per la durata è selezionato nel tuo piano',
        subscriptionSuccess: 'Hai sottoscritto il piano da te selezionato',
        subscriptionFailure:
          'Un errore è avvenuto durante la sottoscrizione al piano selezionato. Prego contattare un amministratore o riprovare più tardi.',
        unsubscriptionSuccess:
          'Hai rimosso la sottoscrizione al piano selezionato',
        unsubscriptionFailure:
          'Un errore è avvenuto durante la rimozione della sottoscrizione al piano selezionato. Prego contattare un amministratore o riprovare più tardi.',
        resubscriptionSuccess: 'Hai ripristinato il tuo piano',
        resubscriptionFailure:
          'Un errore è avvenuto mentre ripristinavi il tuo piano, contatta il tuo amministratore.',
        month: 'Mese',
        cancelsAt: 'Sottoscrizione termina il: ',
        free: 'Gratis',
        silver: 'Argento',
        gold: 'Oro',
        basic: 'Basic',
        essential: 'Essential',
        enterprise: 'Enterprise',
        custom: 'Custom',
        storage: '{{dataLimit}}Mbs di spazio Cloud',
        orders: 'Crea fino a {{ordersLimit}} ordini',
        clients: 'Invita fino a {{clients}} clienti',
        supportAvailable: 'Supporto disponibile',
        supportNotAvailable: 'Supporto non disponibile',
        cancel: 'Cancella',
        confirm: 'Conferma',
        upgrade: 'Upgrade',
        cancelConfirmation:
          'Sei sicuro di voler cancellare la tua sottoscrizione?',
        resubscriptionConfirmation:
          'Sei sicuro di voler riprendere la sottoscrizione?',
        subscriptionConfirmation:
          'La tua sottoscrizione verrà aggiornata. Confermi?',
        upgradesubscriptionConfirmation:
          'Sei sicuro di volere cambiare la tua sottoscrizione?',
        subscriptionConsent:
          'Grazie per aver scelto la sottoscrizione per hyperDENT Connect, conferma per continuare.',
        payment: {
          success:
            'Il tuo pagamento è stato ricevuto. Verrai ridiretto a breve.',
          failure:
            'Il pagamento non è stato confermato a causa di una interruzione manuale del processo o a dati invalidi della carta di credito. Verrai ridiretto a breve.',
        },
      },
      usageDetail: {
        title: 'Dettagli di utilizzo',
        resourceName: 'Nome risorsa',
        used: 'Usato',
        limit: 'Limite',
        usagePercentage: 'Percentuale Usata',
        errorMessage: 'Un errore è avvenuto mentre si caricavano i dettagli',
      },
      billing: {
        title: 'Fatturazione',
        custEmail: 'Email cliente',
        custComp: 'Nome Compagnia',
        fromPeriod: 'Periodo dal',
        toPeriod: 'Periodo fino a',
        amount: 'Numero',
        errorMessage:
          'Errore avvenuto durante il caricamento dei dati di fatturazione',
        manage: 'Gestisci fatturazione',
      },
      invoices: {
        title: 'Invoices',
        id: 'ID Fattura',
        itemDesc: 'Descrizione',
        amountDue: 'Importo dovuto',
        download: 'Download',
        isPaid: 'è pagato',
        paid: 'Pagato',
        due: 'Dovuto',
        errorMessage:
          'Un errore è avvenuto mentre si caricava la lista invoices.',
        totalAmountDue: 'Totale dovuto',
        dateDue: 'Data',
        upcoming: 'Successivo invoice',
        buttonOk: 'OK',
      },
    },
    addons: {
      title: 'Add-Ons',
      keepFiles: 'Durata della conservazione dei file',
      days: 'giorni',
      month: 'mese',
    },
  },
  errorBoundary: {
    errorMessage: 'Oops !, qualcosa non ha funzionato',
    errorFix: 'Errore tecnico, stiamo lavorando per ripristinarlo',
  },
  notifications: {
    label: 'Notifiche',
    new: 'Nuova Notifica',
    none: 'Non hai nuove notifiche',
    markAsUnread: 'Segna come non Letto',
    filter: {
      all: 'Tutto',
      unread: 'Non letto',
    },
  },
  reports: {
    download: {
      error: {
        title: 'Errore',
        message: 'Qualcosa è andato male mentre si creava il PDF di report',
      },
      success: {
        title: 'Successo',
        message: 'PDF generato',
      },
    },
    dateFormat: 'Formato data del Report',
  },
  licenseContent: {
    heading: 'License Content',
    placeholder: 'Search License Key',
    licenses: 'Licenses',
    products: 'Products',
    dongleId: 'Dongle Id',
    isNetwork: 'Is Network',
    isCommercial: 'Is Commercial',
    format: 'Format',
    invalid: 'Invalid Key Format',
    detail: 'License Details',
    columns: {
      ticket: 'Ticket',
      product: 'Product',
      licenseExpiry: 'License Expiration',
      maintenanceExpiry: 'Maintenance Expiry',
    },
    detailColumns: {
      code: 'Code',
      expiryDate: 'Expiration Date',
      featureMap: 'Feature Map',
      permissions: 'Permissions',
      information: 'Information',
      formalDongle: 'Former Dongle No.',
      endOfMaintenance: 'END of Maintenance',
      count: 'Count',
      productCode: 'Product Code',
    },
    tabActive: 'Active Licenses',
    tabOrdered: 'Ordered Licenses',
    tabDetails: 'Active Product Details',
  },
  dealer: {
    save: {
      title: 'Reseller Saved',
      message: 'Reseller data has been saved successfully',
    },
    update: {
      title: 'Update',
      message: 'Reseller data has been updated successfully',
    },
    generate: {
      title: 'Generate Components',
      message:
        'Reseller components metadata xml file is being generated. You can refresh the page after some time to check if new metadata file is ready with latest timestamp.',
    },
    settings: {
      title: 'Reseller Settings',
      message: 'Reseller settings have been updated successfully',
    },
    customer: {
      title: 'Customer Saved',
      message: 'Customer data has been saved successfully',
    },
    import: {
      title: 'Import Customers',
      message: 'Customers import has been started successfully',
    },
  },
  dealerManagement: {
    dealerInformation: 'Reseller Management',
    dealerTickets: 'Reseller Tickets',
    dealerConfigTestView: 'Reseller Configuration Result Test View',
    dealerSettings: 'Reseller Settings',
    customerInformation: 'Customer Management',
    licenseContent: 'License Content',
    dealerHome: {
      heading: ' Welcome to the resellers dashboard ',
      navParagraph:
        'You can go to any of the following dashboard views by navigating from the sidebar or from the below mentioned links',
      navMenu: {
        dealerInformation: 'Reseller Information',
        dealerTickets: 'Reseller Tickets',
        dealerConfigTestView: 'Reseller Configuration Result Test View',
        dealerSettings: 'Reseller Settings',
        customerInformation: 'Customer Information',
      },
    },
    heading: 'Resellers Management',
    invitation: 'Invite as User',
    reInvite: 'Reinvite User',
    newUser: 'New Reseller',
    dealerId: 'Reseller Id',
    dealerName: 'Reseller Name',
    name: 'Name',
    componentFile: 'Component File',
    refresh: 'Refresh',
    generate: 'Generate',
    dealerConfig: {
      test: 'Reseller configuration test view',
      ticketFormat: 'Ticket format',
      invalidTicketFormat:
        'Invalid ticket format. Expected format: {{HD_TICKET_FORMAT_STR}}',
      response: 'Result Json',
      wrapResponse: 'Wrap Response Text',
      initialCall: 'Initial Call',
      testMode: 'Test Mode',
      configJson: 'Configuration Json',
      validateJson: 'Validate Json',
      formatJson: 'Format Json',
      validJson: 'JSON configuration is valid',
      invalidJson: 'JSON configuration is invalid',
      readyForProduction: 'Ready for production',
      viewResult: 'View configuration result',
      verifyResult: 'Verify Components',
      confirm: 'Confirm',
      confirmToProdTitle: 'Push to production?',
      confirmToProdMessage:
        'Configuration Json will be pushed to production. In case of incorrect configuration, user(s) might face issues during components installation process. Are you satisfied to mark it ready for proudction?',
      saveToProdTitle: 'Save to production',
      saveToProdSuccess: 'Configuration Json has been saved to production',
      saveToProdError:
        'An error occured while saving configuration Json to production',
      configTypeNotSupported:
        'Configuration type associated against the dealer is currently different than Fixed Json. Configuration type should be Fixed Json to use this functionality.',
      missingMandatory: 'Missing mandatory components',
      missingOptional: 'Missing optional components',
      noMissingComponents: 'All components exist.',
      verifyResultTitle: 'Verification Result',
      close: 'Close',
      saveDraft: 'Save Draft',
      saveDraftMessage: 'Configuration Json draft has been saved successfully',
    },
    configurations: {
      subDealerAllowed: 'Can Create Sub Resellers',
      ownConfigAllowed: 'Can Set Own Configurations',
      strictModeConfiguration: 'Apply Strict Configuration',
      parentDealerId: 'Parent Reseller Id',
      parentDealerName: 'Parent Reseller Name',
      heading: 'Configurations',
      baseURL: 'Components Base URL',
      configType: 'Config Type',
      json: 'Configurations Json',
      file: 'Configurations File',
      url: 'Configurations Url',
    },
    contact: {
      dealerContact: 'Reseller Contact',
      supportContact: 'Support Contact',
      salesContact: 'Sales Contact',
      address1: 'Address 1',
      address2: 'Address 2',
      address3: 'Address 3',
      zipCode: 'Zip Code',
      city: 'City',
      district: 'District',
      state: 'State',
      country: 'Country',
      phone: 'Phone',
      email: 'Email',
      webUrl: 'Web Url',
      showInfoToOutOfMaintenanceUsers: 'Show Info To Out Of Maintenance Users',
    },
    configOptions: {
      none: 'None',
      fixedJson: 'Fixed Json',
      fixedFile: 'Fixed File',
      dynamicUrl: 'Dynamic Url',
    },
    buttonSave: 'Save',
    buttonSaveAndSelect: 'Save & Select',
    user: {
      heading: 'User Management',
      newUser: 'New User',
      dealer: 'Reseller',
      manager: 'Manager',
      columns: {
        firstName: 'First Name',
        lastName: 'Last Name',
        email: 'Email',
        role: 'Role',
        actions: 'Actions',
      },
    },
    updateConfirm: {
      title: 'Update E-Mail',
      message:
        'User will need to use this email to log in later. Please confirm?',
      messageSelf:
        'You are updating your email. You will be logged out immediately and can log in later with the updated email after confirmation. Do you want to proceed?',
      buttonOk: 'Update',
      buttonCancel: 'Cancel',
    },
    updateTicketDealerConfirm: {
      title: 'Update Ticket Reseller',
      message:
        'Customers selection will be reset on updating the Reseller. Please confirm?',
      buttonOk: 'Update',
      buttonCancel: 'Cancel',
    },
    requiredDealerId: 'Reseller Id is required',
    requiredName: 'Reseller Name is required',
    requiredConfigType: 'Configuration Type is required',
    invalidJson: 'Invalid JSON',
    requiredParentEmail: 'Parent Reseller Id or Email is required',
    emailNotValid: 'Email is not valid',
    tickets: {
      all: 'All',
      title: 'Reseller Tickets',
      ticketsFound: '{{totalSize}} ticket(s) found',
      rowsSelected: '{{rowsCount}} row(s) selected',
      archiveSelected: 'Archive selected',
      unarchiveSelected: 'Unarchive selected',
      dataColumns: {
        ticketId: 'Ticket Id',
        activationStatus: 'Activation Status',
        productText: 'Product Text',
        expiryDate: 'Expiry Date',
        licenseQuantity: 'Quantity',
        maintenanceExpiry: 'Maintenance Expiry',
        parentDealerId: 'Parent Reseller Id',
        dealerId: 'Reseller Id',
        isWibuUpdateAvailable: 'Update Available',
        minimumExpiryDate: 'Minimum Expiry Date',
        expiryInDays: 'Expiry In Days',
        ticketInfo: 'Ticket Info',
      },
      pageSize: 'Page Size',
      noActiveTicketsFound:
        'No active product detail found against ticketId "{{ticketId}}"',
      dealersList: 'Resellers List',
    },
    settings: {
      title: 'Settings',
      pageSize: 'Page Size',
      language: 'Language',
      sendNotifications: 'Activate',
      notificationsActiveDays: 'Remind before expiry days',
      notificationsOccurrence: 'Occurrence',
      includeExpiredProducts: 'Include Expired Products',
      includeExpiredProductsOptions: 'Include Expired Products Options',
    },
    placeholders: {
      fmCustomerPlaceholder: 'Enter FM Customer',
      fmCustomerDescriptionPlaceholder: 'Enter FM Customer Description',
      dealerPlaceholder: 'Select Reseller',
      customerPlaceholder: 'Select Customer',
    },
  },
  managerManagement: {
    usersView: 'hdConnect MillingCenter Users',
    millsView: 'MillingCenters Overview',
    ordersView: 'MillingCenters Orders View',
    hdUsageInfo: 'hyperDENT Concurrent Usage View',
    userActivity: 'MillingCenters Activity Overview',
    dealerConfigTestView: 'Resellers configuration test view',
    dealerActivity: 'Resellers View',
    customerActivity: 'Customers View',
    userManagement: 'User Management',
    settings: 'Settings',
    importCustomers: 'Import Customers',
    customerLabel: 'Customer',
    fmCustomerLabel: 'FM Customer',
  },
  hdUsageInfo: {
    usageInfo: 'hyperDENT Usage Info',
    runningMachines: 'Running Machines',
    concurrentUsers: 'Concurrent Users',
    lastUpdateReceivedAt: 'Last Update Received At',
    licenseKey: 'License Key',
    allowedUsers: 'Allowed Network Users',
    mulipleLogins: 'Multiple Logins',
    firstPing: 'First Ping Received At',
    lastPing: 'Recent Ping Received At',
    concurrentlyUsedCount: 'Concurrently Used Count',
    hdVersion: 'hyperDENT Version',
  },
  unknownError: 'An unknown error occured',
  customerManagement: {
    customers: 'Customers',
    heading: 'Customers Management',
    create: 'Create Customer',
    newUser: 'New Customer',
    customer: 'Customer',
    customerId: 'Customer Id',
    fmCustomerId: 'FM Customer Id',
    fmCustomerDescription: 'FM Customer Description',
    fmDescription: 'FM Description',
    title: 'Title',
    salutation: 'Salutation',
    firstName: 'First Name',
    lastName: 'Last Name',
    position: 'Position',
    company: 'Company',
    contactLabel: 'Contact',
    requiredDealerId: 'Reseller Id is required',
    requiredFirstName: 'First Name is required',
    requiredLastName: 'Last Name is required',
    requiredCompany: 'Company is required',
    requiredParentEmail: 'Parent Reseller Id or Email is required',
    uniqueCustomerId: 'Customer Id must be unique',
    error: {
      title: 'Error',
      customerListProcessing: 'Error processing customer list: {{error}}',
      customerListLoading: 'Failed to load customer list: {{error}}',
      customerTicket: 'Failed to update ticket customer: {{error}}',
      customerUpdate: 'Error updating selected customer',
      customerAssign: 'Error assigning customer',
      dealerTicket: 'Failed to update ticket dealer: {{error}}',
      dealerAssign: 'Error assigning dealer',
    },
    modal: {
      error: 'Please select a customer',
      errorDealer: 'Please select a reseller',
      select: 'Select Customer',
      selectDealer: 'Select Reseller',
      edit: 'Edit Customer',
      addNew: 'View Registration Data',
      close: 'Close',
      viewOnly: 'View Only',
      viewOnlyCustomer: 'View Customer',
    },
    actions: {
      archiveItem: 'Archived',
      unarchiveItem: 'Active',
      archive: 'Archive',
      unarchive: 'Active',
      archiveConfirm: {
        title: 'Archive Ticket',
        message: 'Are you sure you want to archive this ticket?',
        buttonOk: 'Archive',
        buttonCancel: 'Cancel',
      },
      unarchiveConfirm: {
        title: 'Unarchive Ticket',
        message: 'Are you sure you want to unarchive this ticket?',
        buttonOk: 'Unarchive',
      },
      archiveLabel: 'Ticket Status',
    },
    import: {
      heading: 'Import Customers',
      uploadButton: 'Import',
      summaryHeading: 'Data Import Summary: ',
      lastSummaryHeading: 'Last Import Summary: ',
      summary: 'Summary:',
      statusArea: 'Status Area',
      status: 'Status:',
      total: 'Total Rows:',
      success: 'Successful Rows Count:',
      duplicate: 'Duplicate Rows Count:',
      errors: 'Failed Rows Count:',
      running:
        'Import is running in background. An email will be sent on shared email account once it is completed.',
      fileName: 'File Name:',
      importStartTime: 'Import Start Time:',
      importEndTime: 'Import End Time:',
    },
  },
  partsView: {
    heading: 'Parts View',
    columns: {
      name: 'Name',
      partType: 'Part Type',
      height: 'Height',
      status: 'Status',
      lotNumber: 'Lot Number',
      isLocked: 'Is Locked',
      path: 'Path',
      projectFolder: 'Project Folder',
      intendedColor: 'Intended Color',
      intendedTool: 'Intended Tool',
      intendedMaterial: 'Intended Material',
      machineName: 'Machine Name',
      createdAt: 'Created At',
      updatedAt: 'Updated At',
    },
    actions: {
      redo: 'Redo',
      title: 'Redo Part',
      message: 'Are you sure you want to redo this part?',
      buttonOk: 'Redo',
      buttonCancel: 'Cancel',
    },
    redoSuccess: 'Part redone successfully',
    redoSuccessMessage: 'The part has been successfully redone.',
    detailColumns: {
      title: 'Part Details',
      guid: 'GUID',
      stockMaterialName: 'Stock Material',
      lotNumber: 'Lot Number',
      material: 'Material',
      blankType: 'Blank Type',
      storageLocation: 'Storage Location',
      status: 'Status',
      isPreparedAutomatically: 'Prepared Automatically',
      processId: 'Process ID',
      failedReason: 'Failed Reason',
      machineId: 'Machine ID',
    },
  },
  filters: {
    addFilter: 'Add Filter',
    deleteAll: 'Clear All',
    applyFilters: 'Apply Filters',
    selectFilter: 'Select Filter',
    selectStatus: 'Select Status',
  },
};
